/**
 * Model lifecycle copy: stages, metadata accuracy, filters, batch
 * operations and localized API errors. All user-visible strings.
 */
export type LifecycleLocale='tr'|'en'|'de';

const table={
  stageDiscovered: {
    tr:'Keşfedildi · Gateway kaydı yok', en:'Discovered · no Gateway entry', de:'Entdeckt · kein Gateway-Eintrag',
  },
  stagePrepared: {
    tr:'Hazırlandı · kapalı Gateway kaydı var', en:'Prepared · disabled Gateway entry', de:'Vorbereitet · deaktivierter Gateway-Eintrag',
  },
  stageEnabled: {
    tr:'Etkin · Harness onayı bekliyor', en:'Enabled · Harness approval pending', de:'Aktiviert · Harness-Freigabe ausstehend',
  },
  stageAvailable: {
    tr:'Harness izni açık · gerçek yanıt doğrulanmadı', en:'Harness permission enabled · response not verified', de:'Harness-Berechtigung aktiv · Antwort nicht verifiziert',
  },
  stageDisabled: {
    tr:'Kapatıldı', en:'Disabled', de:'Deaktiviert',
  },
  stageUnsupported: {
    tr:'Desteklenmiyor', en:'Unsupported', de:'Nicht unterstützt',
  },
  accuracyVerified: {
    tr:'Metadata doğrulandı (sağlayıcı API)', en:'Metadata verified (provider API)', de:'Metadaten verifiziert (Anbieter-API)',
  },
  accuracyPartial: {
    tr:'Metadata kısmen doğrulandı', en:'Metadata partially verified', de:'Metadaten teilweise verifiziert',
  },
  accuracySafe: {
    tr:'Güvenli çalışma profili · gerçek kapasite bilinmiyor', en:'Safe working profile · real capacity unknown', de:'Sicherheitsprofil · echte Kapazität unbekannt',
  },
  realCapacity: {
    tr:'Gerçek kapasite', en:'Real capacity', de:'Echte Kapazität',
  },
  workingLimit: {
    tr:'KNSAIX çalışma limiti', en:'KNSAIX working limit', de:'KNSAIX-Lauflimit',
  },
  capacityUnknown: {
    tr:'Gerçek kapasite bilinmiyor', en:'Real capacity unknown', de:'Echte Kapazität unbekannt',
  },
  filterAll: {tr:'Tümü', en:'All', de:'Alle'},
  filterSelected: {tr:'Seçili', en:'Selected', de:'Ausgewählt'},
  filterPrepared: {tr:'Hazır', en:'Prepared', de:'Bereit'},
  filterEnabled: {tr:'Etkin', en:'Enabled', de:'Aktiv'},
  filterIssues: {tr:'Sorunlu', en:'Issues', de:'Probleme'},
  filterNoGateway: {tr:'Gateway kaydı yok', en:'No Gateway entry', de:'Kein Gateway-Eintrag'},
  autoPrepare: {tr:'Otomatik hazırla', en:'Prepare automatically', de:'Automatisch vorbereiten'},
  prepareInBatch: {tr:'Seçilenleri hazırla', en:'Prepare selected', de:'Auswahl vorbereiten'},
  selectedMissingCount: {tr:'Hazırlanacak Gateway kaydı: {count}',en:'Gateway records to prepare: {count}',de:'Vorzubereitende Gateway-Einträge: {count}'},
  batchSafeAcknowledgement: {
    tr:'Gerçek model kapasitesi bilinmeyen modeller için sınırlı çalışma profilini (8192 / 1024) açıkça onaylıyorum. Bu, canlı yanıt testi değildir.',
    en:'I explicitly approve the restricted working profile (8192 / 1024) for models with unknown capacity. This is not a live response test.',
    de:'Ich bestätige ausdrücklich das begrenzte Arbeitsprofil (8192 / 1024) für Modelle mit unbekannter Kapazität. Dies ist kein Live-Antworttest.',
  },
  confirmBatchSafeFirst: {tr:'Toplu güvenli profil onayı gerekli.',en:'Batch safe profile approval is required.',de:'Bestätigung des begrenzten Profils erforderlich.'},
  selectMissingFirst: {tr:'1–50 arasında Gateway kaydı eksik model seç.',en:'Select 1–50 models without Gateway records.',de:'Wähle 1–50 Modelle ohne Gateway-Eintrag.'},
  errorCapabilityUnknown: {tr:'Modelin sohbet özelliği doğrulanamadı; otomatik yayınlanmadı.',en:'Chat capability was not verified; automatic publishing was blocked.',de:'Chat-Funktion wurde nicht bestätigt; automatische Veröffentlichung gesperrt.'},
  enable: {tr:'Etkinleştir', en:'Enable', de:'Aktivieren'},
  disable: {tr:'Kapat', en:'Disable', de:'Deaktivieren'},
  advanced: {tr:'Gelişmiş ayarlar', en:'Advanced settings', de:'Erweiterte Einstellungen'},
  noModelsAtAll: {
    tr:'Hiç katalog modeli yok. Bağlantı testi çalıştırıp modelleri keşfedilmeli.',
    en:'No catalog models yet. Run the connection test to discover models.',
    de:'Noch keine Katalogmodelle. Verbindungstest ausführen, um Modelle zu finden.',
  },
  loadingStage: {
    tr:'Model yaşam döngüsü yükleniyor', en:'Loading model lifecycle', de:'Modell-Lebenszyklus wird geladen',
  },
  safeProfilePrompt: {
    tr:'Bu modelin gerçek kapasitesi sağlayıcı API veya doğrulanmış profiller üzerinden çözülemedi. "Güvenli çalışma profili" ile sınırlı (bağlam 8192, çıktı 1024 token) kapalı bir kayıt oluşturulabilir; model gerçek maksimum kapasiteye sahipmiş gibi gösterilmez.',
    en:'The real capacity of this model could not be resolved from the provider API or verified profiles. A disabled entry can be created with the restricted safe working profile (context 8192, output 1024 tokens); the model will not be presented as if it had larger real capacity.',
    de:'Die echte Kapazität dieses Modells ließ sich weder über die Anbieter-API noch über verifizierte Profile ermitteln. Ein deaktivierter Eintrag kann mit eingeschränktem Sicherheitsprofil (Kontext 8192, Ausgabe 1024 Token) erstellt werden; das Modell wird nicht so dargestellt, als hätte es eine größere echte Kapazität.',
  },
  safeProfileConfirm: {
    tr:'Sınırlı güvenli profille hazırla', en:'Prepare with restricted safe profile', de:'Mit eingeschränktem Profil vorbereiten',
  },
  autoPrepareDone: {
    tr:'{model} için kapalı Gateway kaydı oluşturuldu.', en:'Disabled Gateway entry created for {model}.', de:'Deaktivierter Gateway-Eintrag für {model} erstellt.',
  },
  batchApplied: {
    tr:'Toplu işlem: {ok} uygulandı, {fail} başarısız.', en:'Batch: {ok} applied, {fail} failed.', de:'Stapel: {ok} angewendet, {fail} fehlgeschlagen.',
  },
  batchDetail: {tr:'Model bazında sonuçlar', en:'Per-model results', de:'Ergebnisse pro Modell'},
  batchFailedSome: {
    tr:'Kısmi başarısızlık: model bazında ayrıntıyı aç.', en:'Partial failure: open per-model details.', de:'Teilfehler: Details pro Modell öffnen.',
  },
  selectAllFiltered: {tr:'Filtrelenenleri seç', en:'Select filtered', de:'Gefilterte auswählen'},
  clearSelection: {tr:'Seçimi temizle', en:'Clear selection', de:'Auswahl aufheben'},
  applyPermissions: {tr:'İzinleri uygula', en:'Apply permissions', de:'Berechtigungen anwenden'},
  testModelShort: {tr:'Test', en:'Test', de:'Test'},
  detailShort: {tr:'Ayrıntı', en:'Details', de:'Details'},
  reasonApply: {tr:'İzin nedeni', en:'Permission reason', de:'Berechtigungsgrund'},
  errorSafeProfile: {
    tr:'Güvenli çalışma profili için ayrı onay gerekli. Ayarlı durum panelinde onayı birebir onayla.',
    en:'The safe working profile needs an explicit confirmation. Approve it in the detail panel.',
    de:'Das Sicherheitsprofil erfordert eine eigene Bestätigung. Bestätigen Sie es im Detailbereich.',
  },
  errorDeploymentMissing: {
    tr:'Bu modelin provider_market kaydı yok; geçitli etkinleştirme yolu kapalı. Model kapalı kaldı, izinler yönetim onayı ile açılmalı.',
    en:'This model has no provider_market record; the governed enablement path is closed. The model stays disabled; enablement needs a manager approval record.',
    de:'Für dieses Modell fehlt ein provider_market-Eintrag; der geregelte Freigabeweg ist geschlossen. Das Modell bleibt deaktiviert.',
  },
  errorAuthority: {
    tr:'Model etkinleştirme yetkisi (MODEL_ENABLE) bu oturumda yok.',
    en:'Model enable authority (MODEL_ENABLE) is not held by this session.',
    de:'Die Modellfreigabebefugnis (MODEL_ENABLE) fehlt in dieser Sitzung.',
  },
  errorAlreadyRegistered: {
    tr:'Bu model için zaten Gateway kaydı var.', en:'A Gateway entry already exists for this model.', de:'Für dieses Modell existiert bereits ein Gateway-Eintrag.',
  },
  errorCatalogUnsupported: {
    tr:'Bu sağlayıcı için otomatik katalog yayınlama henüz desteklenmiyor (destekli: nvidia-nim, openrouter).',
    en:'Automatic catalog publishing is not yet supported for this provider (supported: nvidia-nim, openrouter).',
    de:'Automatische Katalogveröffentlichung ist für diesen Anbieter noch nicht unterstützt (unterstützt: nvidia-nim, openrouter).',
  },
  preparedNextTitle: {
    tr:'Model hazırlandı',en:'Model prepared',de:'Modell vorbereitet',
  },
  preparedNextBody: {
    tr:'{model} Gateway listesine eklendi ve güvenlik nedeniyle kapalı. Harness’te kullanmak için yetkili etkinleştirme ve gerçek yanıt testi gerekiyor.',
    en:'{model} was added to the Gateway and remains disabled for safety. Authorized enablement and a real response test are still required for Harness use.',
    de:'{model} wurde dem Gateway hinzugefügt und bleibt aus Sicherheitsgründen deaktiviert. Für Harness sind Freigabe und ein echter Antworttest nötig.',
  },
  viewPreparedModel: {tr:'Hazır modeli göster',en:'View prepared model',de:'Vorbereitetes Modell anzeigen'},
  manageModelAccess: {tr:'Model erişimini yönet',en:'Manage model access',de:'Modellzugriff verwalten'},
  dismissGuidance: {tr:'Kapat',en:'Dismiss',de:'Schließen'},
  modelNotReadyForManage: {
    tr:'Gateway kaydı henüz listede doğrulanamadı. Model listesini yenile.',
    en:'Gateway entry is not yet confirmed in the list. Refresh the model list.',
    de:'Gateway-Eintrag ist noch nicht bestätigt. Aktualisiere die Modellliste.',
  },
  technicalDetails: {tr:'Teknik ayrıntılar',en:'Technical details',de:'Technische Details'},
  errorCodeLabel: {tr:'Hata kodu',en:'Error code',de:'Fehlercode'},
  copyErrorCode: {tr:'Hata kodunu kopyala',en:'Copy error code',de:'Fehlercode kopieren'},
  errorBatchItemFailed: {
    tr:'Model hazırlama sunucuda tamamlanamadı. İşlem geri alındı; aynı işlemi sürekli tekrarlama. Teknik hata kodunu destek için kullan.',
    en:'The server could not complete model preparation. The operation was rolled back. Avoid repeated retries; use the technical code for support.',
    de:'Der Server konnte das Modell nicht vorbereiten. Der Vorgang wurde zurückgesetzt. Bitte nicht wiederholt versuchen; nutze den technischen Code.',
  },
  errorDatabasePermission: {
    tr:'Sunucu veritabanındaki bu kaydı değiştirme yetkisine sahip değil. Bu bir yönetici yapılandırma sorunu; tekrar denemek çözmez.',
    en:'The server has no permission to change this database record. Administrator configuration is required; retrying will not fix it.',
    de:'Der Server hat keine Berechtigung, diesen Datenbankeintrag zu ändern. Die Konfiguration muss administrativ korrigiert werden.',
  },
  errorRateLimited: {
    tr:'Sağlayıcının kullanım sınırına ulaşıldı. Belirtilen bekleme süresinden sonra yeniden dene.',
    en:'Provider usage limit reached. Retry after the indicated delay.',
    de:'Nutzungslimit des Anbieters erreicht. Nach der angegebenen Wartezeit erneut versuchen.',
  },
  errorGeneric: {
    tr:'Yaşam döngüsü reddedildi: {code}', en:'Lifecycle action refused: {code}', de:'Lebenszyklus abgelehnt: {code}',
  },
  lifecycleBlocked: {
    tr:'Değişiklik uygulanmadı, kalıcı durum korundu.', en:'No change was applied; persistent state is preserved.', de:'Keine Änderung angewendet; bestehender Zustand bleibt.',
  },
} as const;

export type LifecycleMessageKey=keyof typeof table;
export type LifecycleParams=Record<string,string|number>;

const ERROR_KEYS:Record<string,LifecycleMessageKey>={
  safe_profile_confirmation_required:'errorSafeProfile',
  deployment_record_missing_permission_path_forbidden:'errorDeploymentMissing',
  model_enable_authority_required:'errorAuthority',
  gateway_model_already_registered:'errorAlreadyRegistered',
  catalog_publish_provider_unsupported:'errorCatalogUnsupported',
  catalog_model_chat_capability_unverified:'errorCapabilityUnknown',
  lifecycle_batch_item_failed:'errorBatchItemFailed',
  gateway_model_write_denied:'errorDatabasePermission',
  rate_limit_exceeded:'errorRateLimited',
};

export function lifecycleMessage(
  locale:string,key:LifecycleMessageKey,parameters:LifecycleParams={},
):string{
  const lang=locale.toLowerCase().split(/[-_]/)[0];
  const text=lang==='en'?table[key].en:lang==='de'?table[key].de:table[key].tr;
  return text.replace(/\{([a-z_]+)\}/g,(_,name:string)=>
    Object.prototype.hasOwnProperty.call(parameters,name)
      ?String(parameters[name])
      :`{${name}}`);
}

export const lifecycleStageLabel=(locale:string,stage:string):string=>{
  const labels:Record<string,LifecycleMessageKey>={
    DISCOVERED:'stageDiscovered',
    PREPARED:'stagePrepared',
    ENABLED:'stageEnabled',
    AVAILABLE_IN_HARNESS:'stageAvailable',
    DISABLED:'stageDisabled',
    UNSUPPORTED:'stageUnsupported',
  };
  const key=labels[stage];
  return key?lifecycleMessage(locale,key):stage;
};

export const lifecycleAccuracyLabel=(
  locale:string,accuracy:string|null|undefined,
):string|null=>{
  const labels:Record<string,LifecycleMessageKey>={
    VERIFIED:'accuracyVerified',
    PARTIAL:'accuracyPartial',
    SAFE_WORKING_PROFILE:'accuracySafe',
  };
  const key=labels[accuracy??''];
  return key?lifecycleMessage(locale,key):accuracy===null||accuracy===undefined?null:accuracy;
};

export const lifecycleErrorText=(locale:string,code:string):string=>{
  const key=ERROR_KEYS[code];
  if(key)return lifecycleMessage(locale,key);
  const shortened=/^[a-z0-9_]+$/.test(code)?code:'lifecycle_request_failed';
  return lifecycleMessage(locale,'errorGeneric',{code:shortened});
};
